.wrap {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.track {
  position: relative;
  flex: none;
  width: 42px;
  height: 24px;
  border-radius: var(--radius-pill);
  border: 0;
  padding: 0;
  background: var(--color-border-strong);
  cursor: pointer;
  transition: background 0.15s var(--ease);
}
.track.on {
  background: var(--color-accent);
}
.track:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.thumb {
  position: absolute;
  top: 3px;
  inset-inline-start: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: var(--shadow-sm);
  transition: inset-inline-start 0.15s var(--ease);
}
.on .thumb {
  inset-inline-start: 21px;
  background: var(--navy);
}
.text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.label {
  font-size: var(--text-sm);
  font-weight: 600;
  cursor: pointer;
}
.desc {
  font-size: var(--text-xs);
  color: var(--color-text-subtle);
}
